export default __webpack_public_path__ + "static/media/offericon.f425c722.svg";